enum DividerTypeEnum {
	thin = 'thin',
	dashed = 'dashed'
}

export default DividerTypeEnum;
